<template>
  <div class="frame-frame-title-font mt-4">
    <p class="uppercase xs-text xs-content">
      Your personal title can be whatever you wish or you can also choose to
      keep your bike pure and not include one.
    </p>
    <p class="uppercase xs-text xs-content">Select which option you prefer</p>
    <ul class="font-selector-wrapper">
      <li v-for="(font, index) in fonts" v-bind:key="font.name">
        <input :id="'ii_' + index" type="radio" name="fontFamily" :value="font.value" v-model="titleFamily"
          style="display: none" />
        <label :for="'ii_' + index" :style="{
          'font-family': font.font,
          'font-weigth': font.bold ? 600 : 400,
          'font-style': font.italic ? 'italic' : '',
        }" :class="{ active: font.name == getCurrentValue() }">{{ font.name }}
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue } from "bootstrap-vue";

// Import Bootstrap an BootstrapVue CSS files
import "bootstrap/dist/js/bootstrap.js";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
export default {
  name: "frame-frame-title-font",
  props: ["results"],
  data() {
    return {
      fontFamilyValue: null,
      fonts: [
        {
          name: "Passoni font - Capitals",
          font: "Avenir-Book",
          bold: false,
          italic: false,
          uppercase: true,
          value: {
            name: "Passoni font - Capitals",
            font: "Avenir-Book",
            bold: false,
            italic: false,
            uppercase: true,
          },
        },
        {
          name: "Passoni font - Mixed Case",
          font: "Avenir-Book",
          bold: false,
          italic: false,
          uppercase: false,
          value: {
            name: "Passoni font - Mixed Case",
            font: "Avenir-Book",
            bold: false,
            italic: false,
            uppercase: false,
          },
        },
        {
          name: "Script font - Mixed Case",
          font: "Avenir-Book",
          bold: false,
          italic: false,
          uppercase: false,
          value: {
            name: "Script font - Mixed Case",
            font: "Avenir-Book",
            bold: false,
            italic: false,
            uppercase: false,
          },
        },
        {
          name: "No personal title",
          font: "inherit",
          bold: false,
          italic: false,
          uppercase: false,
          value: null,
        },
      ],
    };
  },
  computed: {
    titleFamily: {
      get: function () {
        return this.results.frame.title.family;
      },
      set: function (e) {
        this.$emit("update-title-font", e);
      },
    },
  },
  methods: {
    getCurrentValue: function () {
      return this.results.frame.title.family
      ? this.results.frame.title.family.name
      : 'No personal title';
    },
  }
};
</script>

<style lang="scss" scoped>

.frame-frame-title-font {
  ul {
    padding: 0;
    list-style: none;
    margin-bottom: 0;
    margin-top: 1rem;

    li {
      margin-bottom: 10px;
      font-size: 120%;
      color: #888;

      .active {
        color: black;
      }

      label {
        cursor: pointer;
        padding: 0;
      }
    }
  }
}
</style>